import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Intro } from './types';
import { introReducerPath } from './const';

export * from './const';
export * from './selectors';
export * from './types';

const initialState: Intro = {
  catalogType: undefined,
  careerId: undefined,
};

export const introSlice = createSlice({
  name: `@@app/${introReducerPath}`,
  initialState,
  reducers: {
    reset() {
      return { ...initialState };
    },
    setCatalogType(state, action: PayloadAction<Intro['catalogType']>) {
      state.catalogType = action.payload;
    },
    setCareerId(state, action: PayloadAction<Intro['careerId']>) {
      state.careerId = action.payload;
    },
  },
});
